import { CheckoutState } from "./checkout.state";
import { createSelector, createFeatureSelector } from "@ngrx/store";

export const checkoutStateSelector = createFeatureSelector<CheckoutState>("checkout");

export const checkoutSelector = createSelector(checkoutStateSelector, (state) => state);
export const checkoutCurrentStepSelector = createSelector(checkoutStateSelector, (state) => state?.currentStep);
export const checkoutAboutYouSelector = createSelector(checkoutStateSelector, (state) => state?.steps?.aboutYou);
export const checkoutStepsSelector = createSelector(checkoutStateSelector, (state) => {
	const virtualState = { ...state?.steps };
	try {
		delete virtualState?.terms;
	} catch (error) {
		console.log("couldnt delete terms");
	}
	return virtualState;
});
export const checkoutSetupMobileSelector = createSelector(checkoutStateSelector, (state) => state?.steps?.setup?.mobile);
export const checkoutContinueSelector = createSelector(checkoutStateSelector, (state) => state?.continue);
export const checkoutPaymentSelector = createSelector(checkoutStateSelector, (state) => state?.steps?.paymentDetails);
export const checkoutTermsSelector = createSelector(checkoutStateSelector, (state) => state?.steps?.terms);
export const iframeSelector = createSelector(checkoutStateSelector, (state) => state?.steps?.paymentDetails?.iframe);
export const checkoutInfoSelector = createSelector(checkoutStateSelector, (state) => state?.info);
export const leadWithUserDetailsSelector = createSelector(
	checkoutAboutYouSelector,
	checkoutInfoSelector,
	(aboutYou, lead) => ({ aboutYou, lead })
);
export const checkoutCustomerDataSelector = createSelector(checkoutStateSelector, (state) => state?.customerData);
export const checkoutProofOfIdSelector = createSelector(checkoutStateSelector, (state) => state?.steps?.proofOfId);

// export const checkoutSetupEnergySelector = createSelector(checkoutStateSelector, (state) => state?.steps?.setup?.energy);
